import React from 'react';
import styled from 'styled-components';
import Visitor from '../../components/layouts/Visitor';
import HeaderOne from '../../components/parts/HeaderOne';
import LoginForm from '../../components/combinations/LoginForm';
import LinkText from '../../components/parts/LinkText';
import Divider from '../../components/parts/Divider';
import UserHead from "../../config/UserHead";

const LoginStyle = styled.div`
  background: white;
  border-radius: 25px;
  text-align: center;
  padding: 20px 30px;
  margin: 30px;

  @media (max-width: 767px) {
    margin: 30px 10px;
  }
`;

const HeaderOneStyle = styled(HeaderOne)`
  margin-bottom: 20px;
`;

const ToLoginPageStyle = styled(LinkText)`
  text-align: center;
  text-decoration: underline;
`;

const ToPasswordResetPageStyle = styled(LinkText)`
  text-align: center;
  text-decoration: underline;
`;

const Login: React.FC = (() => {

  return (
    <Visitor>
      <UserHead title='ログイン' />
      <LoginStyle>
        <HeaderOneStyle>ログイン</HeaderOneStyle>
        <LoginForm />
        <ToLoginPageStyle href='/user/sign-up'>初めてご利用の方はこちら</ToLoginPageStyle>
        <Divider mt='20px' mb='20px' />
        <ToPasswordResetPageStyle href='/user/password-reset-reception'>パスワードを忘れた方</ToPasswordResetPageStyle>
      </LoginStyle>
    </Visitor>
  );
});
export default Login;
